import './FiFeLegDialog.scss';

import * as angular from 'angular';

import { Component } from '../Component';
import { FiFurnitureService } from '../fiFurniture/FiFurnitureService';

@Component({
    controllerAs: 'vm',
    template: require('./FiFeLegDialog.html'),
    bindings: {
        hideButton: '<' 
    },
})
export class FiFeLegDialog {
    static $inject = [
        '$mdDialog',
        'fiFurnitureService',
        '$window',
    ];

    constructor(
        private $mdDialog: angular.material.IDialogService,
        private fs: FiFurnitureService,
        private $window: angular.IWindowService,
    ) {
        //
    }

    $onInit() {
        //
    }

    next() {
        const index = this.fs.items.sort((a, b) => a.code.localeCompare(b.code)).indexOf(this.fs.legItem);
        const nextItem = index + 1;
        if (nextItem == this.fs.items.length) {
            return false;
        }
        else {
            this.fs.legItem = this.fs.items[nextItem];
        }
    }

    previous() {

        const index = this.fs.items.sort((a, b) => a.code.localeCompare(b.code)).indexOf(this.fs.legItem);
        const nextItem = index - 1;
        if (nextItem < 0) {
            return false;
        }
        else {
            this.fs.legItem = this.fs.items[nextItem];
        }
    }

    select() {
        this.fs.furniture.plinth.legs = this.fs.legItem;
        this.$mdDialog.cancel();
    }

    close() {
        this.$mdDialog.cancel();
    }

    viewImage(img) {
        this.$window.open('/img/legs_large/' + img, '_blank');
    }
}